import Vue from 'vue'
//import * as VueGlide from 'vue-glide-js'
import VueGlide from 'vue-glide-js'
 
Vue.use(VueGlide)